export const toSn = [
  { title: '首纳简介', value: '0' },
  { title: '荣誉介绍', value: '1' },
  { title: '新闻资讯', value: '2' },
  { title: '联系我们', value: '3' }
]

export const product = [
  { title: '汽车太阳膜', value: 'gr', id: 11 },
  { title: '漆面保护膜', value: 'bh', id: 10 },
  { title: '车身改色膜', value: 'gs', id: 12 },
  // { title: '蓝卫仕防火膜', value: 'fh', id: 39 }
]

export const serviceArr = [
  { title: '门店查询', value: 'https://jinlannami.com/mendianchaxun/' },
  { title: '报价查询', value: '/service/quote' },
  // { title: '报价查询', value: 'https://jinlannami.com/baojiachaxun_qichegeremo/' },
  { title: '质保查询', value: '/warranty/index' },
]
